import axios from "axios";

// Base API URL setup depending on environment
var apiUrl = "https://dripswater.in/api";
if (process.env.NODE_ENV === 'development')
    apiUrl = "https://dripswater.in/api";
else
    apiUrl = "https://dripswater.in/api";

const API = axios.create({ baseURL: apiUrl, withCredentials: true });

// Interceptor to attach Authorization header if token is available in localStorage
API.interceptors.request.use((req) => {
    const profileData = localStorage.getItem("pd");
    
    if (profileData) {
        const parsedData = JSON.parse(profileData);
        const token = parsedData.token; 
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

// Users API
export const login = (requestData) => API.post('/users/login', requestData);
export const logout = (email) => API.post('/users/logout', { email });
export const createUser = (userData) => API.post('/users/create', userData);
export const updateUser = (userData) => API.put('/users/update', userData);
export const deleteUser = (userId) => {
    return API.delete('/users/delete', {
      data: { userId },
    });
};
export const deleteUser2 = (data) => {
    return API.delete('/users/delete', {
      data: {
        email: data.email,
        password: data.password
      },
    });
};
export const getAllUsers = () => API.get('/users/getAllusers');

// OTP-based authentication
export const sendOtp = (data) => API.post('/sendOtp', data);
export const loginWithOtp = (data) => API.post('/login', data);

// Products API
export const addProduct = (productData) => API.post('/products/add', productData);
export const updateProduct = (productData) => API.put(`/products/updateProduct`, productData);
export const deleteProduct = (productCode) => API.delete(`/products/deleteProduct/`, { data: { productCode } });
export const getAllProducts = () => API.get('/getAllProducts');

// Delivery Personnel API
export const createDeliveryPersonnel = (personnelData) => API.post('/createDeliveryPersonnel', personnelData);
export const updateDeliveryPersonnel = (personnelData) => API.put(`/updateDeliveryPersonnel`, personnelData);
  
export const deleteDeliveryPersonnel = (email) => API.delete('/delete', { data: { email } });
  
  
export const viewAssignedOrders = () => API.post('/orders/assigned');
export const updateOrderStatus = (statusData) => API.put('/orders/updateStatus', statusData);
export const getAlldeliveryPersonnel = () => API.get('/getAlldeliveryPersonnel');


// Address API
export const addAddress = (addressData) => API.post('/addAddress', addressData);

// Orders API
export const createOrder = (orderData) => API.post('/createorder', orderData);
export const createPayment = (paymentData) => API.post('/createPayment', paymentData);
export const verifyPayment = (paymentData) => API.post('/verifyPayment', paymentData);
export const assignDelivery = (deliveryData) => API.post('/assignDelivery', deliveryData);
export const getOrderUserwise = (user_id) => API.post('/orderUserwise', { user_id });
export const getAllOrders = () => API.get('/getAllorder');
export const getAllBulkOrders = () => API.get('/getBulkOrderlist');

//Bulk order
export const createBulkOrder = (orderData) => API.post('/createBulkOrder', orderData);

// Admin API
export const getOrdersByStatus = (statusData) => API.post('/getOrderdetails', statusData);

// SMS API
export const sendSMS = (smsData) => API.post('/sendMsg', smsData);

//area API
export const getAreas = () => API.get('/regions');
export const createRegion = (regionData) => API.post('/createRegions', regionData);  
export const createSubRegion = (subRegionData) => API.post('/createSubregions', subRegionData);  
export const getSubRegions = (regionName) => API.post('/regions/sub', { regionName: regionName });  
export const updateSubRegion=(regionData) => API.put('/updateSubRegion', regionData)
export const deleteRegion = (regionId) => API.delete('/deleteRegion', { data: regionId });
// FCM Token API
export const updateFCMToken = (tokenData) => API.put('/fcmtoken', tokenData);
export const getFCMToken = (data) => API.post('/fcmtoken', data);

export const updateFCMTokenDeliveryPersonal = (tokenData) => 
    API.put('/updateFCMTokenDeliveryPersonal', tokenData);

export const getFCMTokenDeliveryPersonal = (data) => 
    API.post('/getFCMTokenDeliveryPersonal', data);

export const sendNotification = (notificationData) => 
    API.post('/sendNotification', notificationData);


